// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jItVZn504n_YlVwnxfz_ {
  position: relative;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Section/components/SectionGridRenderer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".scrollableGridWrapper {\n  position: relative;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollableGridWrapper": `jItVZn504n_YlVwnxfz_`
};
export default ___CSS_LOADER_EXPORT___;
